import actionCreators from './actionCreators';

const hydrateTeamFilter = actionCreators.hydrateTeamFilter;
const changePreviousSeasonValue = actionCreators.changePreviousSeasonValue;
const changeTeamSelection = actionCreators.changeTeamSelection;
const changeDivisionSelection = actionCreators.changeDivisionSelection;
const changeConferenceSelection = actionCreators.changeConferenceSelection;
const changeAllSelection = actionCreators.changeAllSelection;
const selectIndividualTeam = actionCreators.selectIndividualTeam;
const toggleCalendarFilter = actionCreators.toggleCalendarFilter;
const toggleTeamFilter = actionCreators.toggleTeamFilter;
const setGameListPreparingToScroll = actionCreators.setGameListPreparingToScroll;

export default {
    hydrateTeamFilter,
    changePreviousSeasonValue,
    changeTeamSelection,
    changeDivisionSelection,
    changeConferenceSelection,
    changeAllSelection,
    selectIndividualTeam,
    toggleCalendarFilter,
    toggleTeamFilter,
    setGameListPreparingToScroll
}